import React from "react";
import { Box, Container } from "@mui/material";
import { ItemList } from "../../components/Item/ItemList";

export const InvItemsPage = () => {
  return (
    <Box  
          sx={{
            minHeight:'100vh',
            background: 'linear-gradient(180deg, #f9fafc 0%, #f2f5f8 100%)',
          }}
        >
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <ItemList />
      </Box>
    </Container>
    </Box>
  );
};
